<script>
	import { handleNameChange } from "../helpers";

	import FormRow from "./FormRow.svelte";
	import FormColumn from "./FormColumn.svelte";
	import Checkbox from "./Checkbox.svelte";

	export let trustName;
	export let trustTrustee;
	export let authorisedToAct;
	export let disabled = null;
	export let required = null;
</script>

<FormRow>
	<FormColumn>
		<h3>Trust Details</h3>
	</FormColumn>
</FormRow>

<FormRow>
	<FormColumn cols="6">
		<label for="trustTrustee" class:isrequired={required}>Name of Trustee</label>
		<input
			{required}
			{disabled}
			type="text"
			bind:value={trustTrustee}
			id="trustTrustee"
			class="form-control"
			on:change={() => (trustTrustee = handleNameChange(trustTrustee))} />
	</FormColumn>
	<FormColumn cols="6">
		<label for="trustName">Trust Name</label>
		<input
			{disabled}
			maxlength="1000"
			type="text"
			bind:value={trustName}
			id="trustName"
			class="form-control"
			on:change={() => (trustName = handleNameChange(trustName))} />
	</FormColumn>
</FormRow>
<FormRow>
	<FormColumn>
		<Checkbox
			{disabled}
			bind:checked={authorisedToAct}
			label="I am authorised to act on behalf of the Trust"
			{required}
			id="autht"></Checkbox>
	</FormColumn>
</FormRow>
